(function () {
    const modalOpenLinks = document.querySelectorAll('[data-modal-open], .data-modal-open > a')
    const modals = document.querySelectorAll('[data-modal]')

    if (modalOpenLinks) {
        modalOpenLinks.forEach(link => {
            link.addEventListener('click', e => {
                e.preventDefault()

                const id = link.getAttribute('href')
                const modal = document.querySelector(id)

                if (modal) {
                    modal.classList.add('modal_active');
                }
            })
        })
    }

    if (modals) {
        modals.forEach(modal => {
            const modalClose = modal.querySelectorAll('[data-modal-close]')
            const modalWrap = modal.querySelector('[data-modal-wrap]')

            if (modalClose) {
                modalClose.forEach(close => {
                    close.addEventListener('click', () => {
                        modal.classList.remove('modal_active')
                    })
                })
            }

            modal.addEventListener('click', (e) => {
                if (!modalWrap.contains(e.target)) {
                    modal.classList.remove('modal_active')
                }
            })
        })
    }
}())
